import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import CustomNavbar from "../../components/CustomNavbar";
// import CustomTable from "../../components/CustomTable";
import CustomTableCapacitacion from "../../components/capacitacionDesarrollo/CustomTableCapacitacion";
import CustomPagint from "../../components/CustomPagint";

import SidebarDashboard from "../../components/SidebarDashboard";
import { getEmployeeMonitorEvents } from "../../redux/capacitacionDesarrollo/EmployeeMonitor/actions";
import Multiselect from "../../components/Clima/Multiselect";
import { getDivision } from "../../redux/division/actions";
import { getOrgs } from "../../redux/organization/actions";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";
import { useHistory } from "react-router-dom";
import ReactChipInput from "react-chip-input";

import {
  getCompanyResponsibleSelects
} from "../../redux/CompanyResponsibles/actions"

const EmployeeMonitor = (props) => {
  const fecha = new Date();
  var n = fecha.getFullYear();

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState('[""]');
  const [show, setShow] = useState(false);
  const [_orgs, setOrgs] = useState([]);
  const [_orgsId, setOrgsId] = useState("");
  const [validOrgs, setValidOrgs] = useState(true);
  const [submitOrgs, setSubmitOrgs] = useState(false);
  const [_division, setDivision] = useState([]);
  const [_divisionId, setDivisionId] = useState("");
  const [validDivision, setValidDivision] = useState(true);
  const [submitDivision, setSubmitDivision] = useState(false);
  const [_areas, setAreas] = useState([]);
  const [_areasId, setAreasId] = useState("");
  const [validAreas, setValidAreas] = useState(true);
  const [submitAreas, setSubmitAreas] = useState(false);
  const [chips, setChips] = useState([]);
  const [_anio, setAnio] = useState(n);
  const [view, setView] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const userRoles = useSelector((store) => store.auth.userRoles);
  const username = useSelector((store) => store.auth.username);

  const {
    loaderEmployeeMonitor,
    employeeMonitor,
    employeeMonitorFalla,
    employeeMonitorFormError,
  } = useSelector((store) => store.employeeMonitorCapacitation);
  const pages = Math.ceil(employeeMonitor ? employeeMonitor.count / limit : 0);

  const { division } = useSelector((store) => store.division);
  const divisionLoading = useSelector((store) => store.division.loading);

  const areas = useSelector((store) => store.areas.areas);
  const loadingAreas = useSelector((store) => store.areas.loading);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  const {
    companyResponsiblesSelect
  } = useSelector((store) => store.companyResponsible);

  var listOrgs = [];
  
  const sourceList = userRoles.includes("administrador")
  ? data
  : companyResponsiblesSelect?.[0]?.empresas || [];

// eslint-disable-next-line array-callback-return
sourceList.map((item) => {
  listOrgs = [
    ...listOrgs,
    { value: item.id, label: item.nombre.toUpperCase() }
  ];
});

  let listDivision = [];

  division.map((task) => {
    listDivision = [
      ...listDivision,
      {
        value: task.id,
        label: task.descripcion,
      },
    ];
  });

  var listAreas = [];

  areas
    .filter((e) => e.codigo && e.nombre)
    .map((item) => {
      listAreas = [
        ...listAreas,
        {
          value: item.id,
          codigo: item.codigo,
          label: `${item.codigo ? item.codigo : ""} / ${item.nombre ? item.nombre.toUpperCase() : ""
            }`,
        },
      ];
    });

  const columns = [
    {
      Header: "Código:",
      Filter: "",
      Cell: (value) => <div>{value.row.original.codigo}</div>,
    },
    {
      Header: "Nombre:",
      Filter: "",
      Cell: (value) => <div>{value.row.original.nombre}</div>,
    },
    {
      Header: "Ruta de capacitación:",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.ruta ? value.row.original.ruta : "No hay ruta"}
        </div>
      ),
    },
    {
      Header: "Porcentaje de avance:",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.capacitaciones_completadas_porcentaje
            ? parseInt(value.row.original.capacitaciones_completadas_porcentaje)
            : 0}
          %
        </div>
      ),
    },
    {
      Header: "Capacitaciones completadas:",
      Filter: "",
      Cell: (value) => (
        <div>{value.row.original.capacitaciones_completadas}</div>
      ),
    },
    {
      Header: "Año:",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.anio ? value.row.original.anio : "No hay año"}
        </div>
      ),
    },
    {
      Header: "Estado:",
      Filter: "",
      Cell: (value) => (
        <div
          className={`p-2 rounded-pill ${value.row.original.estado && value.row.original.estado[0]
              ? "text-white"
              : ""
            } text-center`}
          style={{
            backgroundColor:
              value.row.original.estado && value.row.original.estado[0]
                ? value.row.original.estado[0].color
                : "",
            minWidth: "90px",
          }}
        >
          {value.row.original.estado && value.row.original.estado[0]
            ? value.row.original.estado[0].descripcion
            : "Sin estado"}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Ir a monitor de capacitacion</Tooltip>}
          >
            <Button
              size="sm"
              className="text-info"
              variant="link"
              type="button"
              onClick={() =>
                history.push(
                  `/capacitacion-desarrollo/monitor-detalle/${value.row.original.id_empleado}/${value.row.original.nombre}/${value.row.original.campania_id}`
                )
              }
            >
              <i className="material-icons">call_missed_outgoing</i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  const _getEmployeeMonitorEvents = (
    offs = offset,
    lim = limit,
    filt = filter,
    orgas = _orgsId,
    division = _divisionId,
    areas = _areasId,
    _ani = _anio,
    viw = view
  ) =>
    dispatch(
      getEmployeeMonitorEvents({
        offset: offs,
        limit: lim,
        empleado: filt,
        empresa: orgas,
        departamento: division,
        unidad_organizativa: areas,
        filter_anio: _ani,
        vista: viw,
      })
    );

  useEffect(() => {
    if (userRoles.length > 0) {
      const rolActual = userRoles.filter(
        (usr) =>
          usr === "jefe" ||
          usr === "administrador" ||
          usr === "Responsable_Capacitacion" ||
          usr === "alta_direccion" ||
          usr === "empleado" 
          
      )[0];
      setView(rolActual);
      _getEmployeeMonitorEvents(
        offset,
        limit,
        filter,
        _orgsId,
        _divisionId,
        _areasId,
        _anio,
        rolActual,
        props.match.params.isEvaluable
      );
    }
  }, [userRoles, _anio]);


  useEffect(() => {
    // _getEmployeeMonitorEvents();
    dispatch(getDivision({}));
    dispatch(getOrgs(parseInt(2)));
    dispatch(getAreasJerarquia({}, 2, true));
    dispatch(getCompanyResponsibleSelects({
      filter_kwargs: {"username": username}
    }))
  }, []);

  // useEffect(() => {
  //   _getEmployeeMonitorEvents();
  // }, [_anio]);

  useEffect(() => {
    if (showModal) {
      document.getElementsByName("chipInput")[0].placeholder = "Empleado";
    }
  }, [showModal]);

  const onOpenSearch = () => {
    setChips([]);
    setValidOrgs(true);
    setSubmitOrgs(false);
    setOrgs([]);
    setValidDivision(true);
    setSubmitDivision(false);
    setDivision([]);
    setValidAreas(true);
    setSubmitAreas(false);
    setAreas([]);
    setShowModal(true);
  };

  useEffect(() => {
    if (
      // userRoles.length > 0 &&
      // (userRoles.includes("administrador") ||
      //   userRoles.includes("Responsable_Capacitacion"))
      view === "administrador" ||
      view === "Responsable_Capacitacion"
    ) {
      onOpenSearch();
    }
  }, [view]);

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitorEvents(oOffset, limit, `["${e.target.filter.value}"]`);
  };

  const onSearchForm = async (req) => {
    let idOrg = "";
    _orgs.map((item, index) => {
      if (parseInt(index) === 0) {
        idOrg += `["${item.label}"`;
      } else {
        idOrg += `"${item.label}"`;
      }
      if (!_orgs[parseInt(index) + 1]) {
        idOrg += `]`;
      } else {
        idOrg += `,`;
      }
    });
    setOrgsId(idOrg);
    let idDiv = "";
    _division.map((item, index) => {
      if (parseInt(index) === 0) {
        idDiv += `["${item.label}"`;
      } else {
        idDiv += `"${item.label}"`;
      }
      if (!_division[parseInt(index) + 1]) {
        idDiv += `]`;
      } else {
        idDiv += `,`;
      }
    });
    setDivisionId(idDiv);
    let idArea = "";
    _areas.map((item, index) => {
      if (parseInt(index) === 0) {
        idArea += `["${item.codigo}"`;
      } else {
        idArea += `"${item.codigo}"`;
      }
      if (!_areas[parseInt(index) + 1]) {
        idArea += `]`;
      } else {
        idArea += `,`;
      }
    });
    let idChips = "";
    chips.map((item, index) => {
      if (parseInt(index) === 0) {
        idChips += `["${item}"`;
      } else {
        idChips += `"${item}"`;
      }
      if (!chips[parseInt(index) + 1]) {
        idChips += `]`;
      } else {
        idChips += `,`;
      }
    });
    setAreasId(idArea);
    setFilter(idChips);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitorEvents(oOffset, limit, idChips, idOrg, idDiv, idArea);
    setShowModal(false);
  };

  const onSearchRole = (e) => {
    e.preventDefault();
    setView(e.currentTarget.value);
    setFilter('[""]');
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitorEvents(
      offset,
      limit,
      '[""]',
      "",
      "",
      "",
      n,
      e.currentTarget.value
    );
    setOrgsId("");
    setDivisionId("");
    setAreasId("");
    setAnio(n);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getEmployeeMonitorEvents(oOffset, limit, `["${oSearch}"]`);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        {console.log(view)}
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <Col
              xs="auto"
              className="d-flex flex-wrap justify-content-start align-items-center"
            >
              <Row className="d-flex flex-wrap justify-content-start align-items-center">
                <div
                  style={{
                    width: "520px",
                  }}
                >
                  <h6 className="text-uppercase">
                    <b>Monitor de colaboradores</b>
                  </h6>
                </div>
              </Row>
            </Col>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                {
                  // userRoles.length > 0 &&
                  // userRoles.includes("administrador") ||
                  // userRoles.includes("alta_direccion") ||
                  // userRoles.includes("Responsable_Capacitacion") ||
                  // userRoles.includes("jefe")
                  (view === "administrador" ||
                    view === "alta_direccion" ||
                    view === "Responsable_Capacitacion" ||
                    view === "jefe") && (
                    <Col xs="auto">
                      <Row>
                        <Form.Label column xs="auto">
                          <b>Buscar:</b>
                        </Form.Label>
                        <Col md="8" xs="auto" className="px-0">
                          <Form.Control
                            name="filter"
                            id="filter"
                            // placeholder={`${tipoBusqueda.desc}`}
                            placeholder="Código o nombre del empleado"
                            className="rounded-pill form-control-sm"
                            type="search"
                          ></Form.Control>
                        </Col>
                      </Row>
                    </Col>
                  )
                }
                <Col xs="auto">
                  <ButtonGroup>
                    {
                      // userRoles.length > 0 &&
                      // userRoles.includes("administrador") ||
                      // userRoles.includes("Responsable_Capacitacion") ||
                      // userRoles.includes("jefe")
                      (view === "administrador" ||
                        view === "alta_direccion" ||
                        view === "Responsable_Capacitacion" ||
                        view === "jefe") && (
                        <>
                          <Button
                            onClick={() => seeAll()}
                            variant="light"
                            size="sm"
                            className="rounded-circle mr-1"
                          >
                            <i className="material-icons">list</i>
                          </Button>
                          <OverlayTrigger
                            placement="auto"
                            overlay={
                              <Tooltip {...props}>Búsqueda avanzada</Tooltip>
                            }
                          >
                            <Button
                              variant="light"
                              size="sm"
                              className="rounded-circle"
                              onClick={() => onOpenSearch()}
                            >
                              <i className="material-icons">search</i>
                            </Button>
                          </OverlayTrigger>
                        </>
                      )
                    }
                  </ButtonGroup>
                  {
                    // userRoles.length > 0 && userRoles.includes("empleado")
                    view === "empleado" && (
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>
                            Ir a Plataforma Educativa
                          </Tooltip>
                        }
                      >
                        <a
                          size="sm"
                          variant="light"
                          className="btn btn-light text-dark rounded-pill py-1 px-2 mr-1"
                          href="http://172.16.2.194/moodle/"
                          target="_blank"
                        >
                          Plataforma Educativa
                        </a>
                      </OverlayTrigger>
                    )
                  }
                </Col>
              </Row>
            </Form>
          </div>
          <Row className="mx-2 px-1 justify-content-start align-items-center flex-nowrap">
            {userRoles.filter(
              (usr) =>
                usr === "jefe" ||
                usr === "administrador" ||
                usr === "empleado" ||
                usr === "Responsable_Capacitacion" ||
                usr === "alta_direccion"
            ).length > 1 ? (
              <>
                <Col xs="auto">
                  <h6>
                    <b>Ver como:</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {/* loadingAuth, users */}
                  <Form.Control
                    as="select"
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    onChange={onSearchRole}
                    style={{ minWidth: "174px" }}
                  >
                    {userRoles
                      .filter(
                        (usr) =>
                          usr === "jefe" ||
                          usr === "administrador" ||
                          usr === "empleado" ||
                          usr === "Responsable_Capacitacion" ||
                          usr === "alta_direccion"
                      )
                      .map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                  </Form.Control>
                </Col>
              </>
            ) : null}
          </Row>
          <div className="px-2">
            <hr />
          </div>
          <div className="px-3 mb-1">
            <Row className="d-flex flex-wrap align-items-center">
              <Col
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={2}
                className="border border-danger rounded shadow mx-2 my-1"
              >
                <div className="text-danger text-center">
                  <p>
                    <b>
                      {employeeMonitor && employeeMonitor.promedio
                        ? employeeMonitor.promedio
                        : 0}
                      %
                    </b>
                  </p>
                  <p className="mt-0">
                    <b>Cumplimiento</b>
                  </p>
                </div>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={2}
                className="border border-primary rounded shadow mx-2 my-1"
              >
                <div className="text-primary text-center">
                  <p>
                    <b>
                      {employeeMonitor && employeeMonitor.meta_anio
                        ? employeeMonitor.meta_anio
                        : 0}
                      %
                    </b>
                  </p>
                </div>
                <Col className="text-primary text-center">
                  <p>
                    <b>Meta</b>
                  </p>
                </Col>
              </Col>
              <Col
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={2}
                className="border border-warning rounded shadow mx-2 my-1"
              >
                <div className="text-warning text-center">
                  <p>
                    <b>
                      {employeeMonitor && employeeMonitor.diferencia_meta
                        ? employeeMonitor.diferencia_meta
                        : 0}
                      %
                    </b>
                  </p>
                </div>
                <Col className="text-warning text-center">
                  <p>
                    <b>Desviación</b>
                  </p>
                </Col>
              </Col>
              <div className="ml-auto d-flex flex-wrap justify-content-end align-items-center">
                <Button
                  className="rounded-pill mr-1 sm-mb-2"
                  // disabled
                  onClick={() => {
                    setAnio(n);
                  }}
                  variant="secondary"
                  type="submit"
                >
                  Año actual
                </Button>
                <Button
                  className="rounded-pill"
                  onClick={() => {
                    setAnio("");
                  }}
                  variant="secondary"
                  type="submit">
                  Historial
                </Button>
              </div>
            </Row>
          </div>
          {loaderEmployeeMonitor ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            employeeMonitor &&
            employeeMonitor.count > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTableCapacitacion
                      columns={columns}
                      data={employeeMonitor.data}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={employeeMonitor.count}
                  pages={pages}
                  pagFunc={_getEmployeeMonitorEvents}
                />
              </>
            )
          )}
          {!loaderEmployeeMonitor &&
            employeeMonitor &&
            employeeMonitor.count === 0 &&
            (!employeeMonitorFalla || employeeMonitorFalla === "") && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comuníquese con el administrador para más
                información.
              </Alert>
            )}
          {employeeMonitorFalla && (
            <Alert variant="danger" className="mt-4 mb-1">
              {employeeMonitorFalla}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-muted">Búsqueda avanzada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!!employeeMonitorFormError && (
            <Alert variant="danger" className="my-1">
              {employeeMonitorFormError}
            </Alert>
          )}
          {
            // userRoles.length > 0 &&
            // userRoles.includes("administrador") ||
            // userRoles.includes("Responsable_Capacitacion")
            view === "administrador" || view === "Responsable_Capacitacion" ? (
              <>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Empresa:
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingOrgs ? "10" : "12"}>
                        <Multiselect
                          options={listOrgs}
                          value={_orgs}
                          onChange={setOrgs}
                          isValid={validOrgs}
                          isDisabled={loadingOrgs}
                          isSubmit={submitOrgs}
                        />
                      </Col>
                      {loadingOrgs && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    División:
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={divisionLoading ? "10" : "12"}>
                        <Multiselect
                          options={listDivision}
                          value={_division}
                          onChange={setDivision}
                          isValid={validDivision}
                          isDisabled={divisionLoading}
                          isSubmit={submitDivision}
                        />
                      </Col>
                      {divisionLoading && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-md-0">
                  <Form.Label column sm={3}>
                    Unidad organizativa:
                  </Form.Label>
                  <Col sm={9}>
                    <Row className="d-flex flex-wrap align-items-center">
                      <Col sm={loadingAreas ? "10" : "12"}>
                        <Multiselect
                          options={listAreas}
                          value={_areas}
                          onChange={setAreas}
                          isValid={validAreas}
                          isDisabled={loadingAreas}
                          isSubmit={submitAreas}
                        />
                      </Col>
                      {loadingAreas && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Form.Group>
              </>
            ) : null
          }
          <Form.Group as={Row}>
            <Form.Label column sm={3}>
              Empleado:
            </Form.Label>
            <Col sm={9}>
              <Row>
                <Col sm={12}>
                  <ReactChipInput
                    chips={chips}
                    placeholder="Código o nombre del empleado"
                    onSubmit={(value) => {
                      const _chips = chips.slice();
                      _chips.push(value);
                      setChips(_chips);
                    }}
                    onRemove={(index) => {
                      const _chips = chips.slice();
                      _chips.splice(index, 1);
                      setChips(_chips);
                    }}
                  />
                </Col>
              </Row>
              <div>
                <small className="text-muted mx-1">
                  <b>Búsqueda por: Código o nombre de empleado</b>
                </small>
              </div>
              <div>
                <small className="text-muted mx-1">
                  <b>
                    (Para agregar los elementos a la lista, presione la tecla
                    "Enter")
                  </b>
                </small>
              </div>
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={() => setShowModal(false)}
          >
            Cerrar
          </Button>
          <Button
            className="rounded-pill"
            disabled={
              loaderEmployeeMonitor ||
              loadingOrgs ||
              divisionLoading ||
              loadingAreas
            }
            variant="primary"
            type="button"
            onClick={(e) => onSearchForm(e)}
          >
            {(loaderEmployeeMonitor ||
              loadingOrgs ||
              divisionLoading ||
              loadingAreas) && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            Buscar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EmployeeMonitor;
